import lodash from 'lodash';
import { reactive, computed } from 'vue';
import {
    createColumnDate, createColumnInput,
    createColumnInputNumber,
    createColumnSelect
} from '../../../../../../components/table/c-table.logic';
import i18n from '../../../../../../i18n';
import store from '../../../../../../store';
import { createLoading } from '../../../../../../utils/loading';
import { createManageExportCsv, createPage } from '../../../../../../utils/page';
import { callProductType } from '../../../../company/company/company.logic';
export const callLabTopic = ({ searchQuery, labTypeKey, where }) => store.dispatch('resource/v1/master/labTopic/cacheFindAll', {
    searchQuery,
    labTypeKey,
    where
});

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = 'resource/v1/transaction/samplingProductAnalysis';
export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });

export const callDepartment = ({ searchQuery, refLabTypeKey }) =>
    store.dispatch('resource/v1/master/department/cacheFindAll', {
        searchQuery,
        where: [
            { name: 'refDepartmentType.key', type: 'String', operator: '=', value: 'LAB' },
            { name: 'refLabType.key', type: 'String', operator: '=', value: refLabTypeKey }
        ]
    });

export const onSearch = ({ page, props, data }) => {
    const where = page.where || [];
    const sort = page.sort || [];
    data.isLoadingDeptProductType = true;
    data.isLoadingDeptProdutTypeLabTopic = true;
    const customWhere = lodash.cloneDeep(where);
    setIsLoading(true);
    window.onSearch?.({ page });

    return callSearch({
        criteria: {
            ...page,
            isDistinct: true,
            data: [],
            where: [
                ...customWhere,
                {
                    name: 'refDepartment.refLabType.key',
                    type: 'String',
                    operator: '=',
                    value: 'labPhysic'
                },
                {
                    name: 'refExtCenterType.id',
                    type: 'UUID',
                    operator: '=',
                    value: null
                },
                {
                    name: 'refSamplingProduct.refSamplingRequest.refSamplingRequestType.key',
                    type: 'String',
                    operator: 'in',
                    value: ['S', 'L']
                },
                { name: 'isActive', type: 'Boolean', operator: '=', value: true },
                { name: 'topics.transferTos.id', type: 'UUID', operator: '=', value: null },
                {
                    name: 'topics.refLabTopic.nameS',
                    type: 'String',
                    isNot: true,
                    operator: 'in',
                    value: ['COL', 'FLAV', 'TXT', 'ODOR', 'CLRN']
                }
            ],
            children : [{
                name: 'topics', select: ['**'], page: 0, size: 100,
            }],
            sort
        }
    }).then(page => {
        page.data.filter(it => it?.refDepartment);
        state.page = { ...page, where, sort };
    }).then(() => {
        initDefaultData({ props }).then((initData) => {
            computedReportDeptProductType({ initData, data });
            computedReportDeptProductTypeTopic({ initData, data });
        });
    }).finally(() => setIsLoading(false));
};


export const createColumnDeptProductTypes = ({ data }) => {
    if (data.columnProductTypes.length == 0)
        callProductType({}).then(productTypes => {
            data.columnProductTypes.push(createColumnSelect({
                title: () => i18n.global.t('views.report.labPhysic.resultByDepartment.department'),
                dataIndex: 'nameTh',
                inputProp: () => ({
                    list: ({ searchQuery }) => callDepartment({ searchQuery, refLabTypeKey: 'labPhysic' }),
                    optLabel: 'nameTh'
                }),
                sorter: false
            }));
            productTypes.forEach(productType => {
                data.columnProductTypes.push(createColumnInputNumber({
                    title: () => productType.value,
                    dataIndex: `${productType.id}.countAccept`,
                    align: 'center',
                    search: { visible: () => false },
                    width: 100,
                    sorter: false
                })),
                    data.columnProductTypes.push(createColumnInputNumber({
                        title: () => productType.value,
                        dataIndex: `${productType.id}.countReject`,
                        align: 'center',
                        search: { visible: () => false },
                        width: 100,
                        sorter: false
                    }));
            });
        });
};


export const createColumnDeptLabTopics = ({ data }) => {
    if (data[`columnLabTopics`] && data[`columnLabTopics`]?.length == 0) {
        callLabTopic({
            labTypeKey: 'labPhysic',
            where: [{ name: 'refParent.id', operator: '=', type: 'UUID', value: null }]
        }).then(labTopics => {
            data[`columnLabTopics`].push(createColumnSelect({
                title: () => i18n.global.t('views.report.labPhysic.resultByDepartment.department'),
                dataIndex: `nameTh`,
                inputProp: () => ({
                    list: ({ searchQuery }) => callDepartment({ searchQuery, refLabTypeKey: 'labPhysic' }),
                    optLabel: 'nameTh'
                }),
                sorter: false
            }));
            labTopics.forEach(labTopic => {
                data[`columnLabTopics`].push(createColumnInputNumber({
                        title: () => labTopic.name,
                        dataIndex: `${labTopic.id}.countReject`,
                        align: 'center',
                        search: { visible: () => false },
                        width: 100,
                        sorter: false
                    })
                );
            });
        });
    }
};

export const initDefaultData = ({ props }) => {
    const { refLabTypeKey } = props;
    if (!state.initData) {
        return Promise.all([
            callProductType({}),
            callLabTopic({
                labTypeKey: 'labPhysic',
                where: [{ name: 'refParent.id', operator: '=', type: 'UUID', value: null }]
            }),
            callDepartment({ refLabTypeKey })
        ]).then(arr => {
            state.initData = {};
            lodash.set(state.initData, 'productTypes', arr[0]);
            lodash.set(state.initData, 'labTopics', arr[1]);
            lodash.set(state.initData, 'labDepartments', arr[2]);
            return Promise.resolve({ productTypes: arr[0], labTopics: arr[1], labDepartments: arr[2] });
        });
    } else {
        return Promise.resolve({
            productTypes: state.initData?.productTypes,
            labTopics: state.initData?.labTopics,
            labDepartments: state.initData?.labDepartments
        });
    }
};

export const getDeptTblRowColumns = ({ reportDatas, rowDatas, colDatas }) => {
    rowDatas?.forEach(row => {
        const colData = Object.assign({}, ...colDatas?.map(col => ({
            [col.id]: {
                ...col,
                countAccept: 0,
                countReject: 0,
                countPending: 0,
                countTotal: 0
            }
        })));
        lodash.merge(row, colData);
        reportDatas.push(lodash.cloneDeep(row));
    });
};

export const computedReportDeptProductType = ({ initData, data }) => {
    const reportDatas = reactive([]);
    if (initData) {
        const { labDepartments, productTypes } = initData;
        const parentDepartments =  labDepartments.map(it => it.refParent)
        getDeptTblRowColumns({ reportDatas: reportDatas, rowDatas: parentDepartments, colDatas: productTypes });
        state.page.data.forEach(analysis => {
            const analysisDeptId = analysis?.refDepartment.refParent?.id;
            const productTypeId = analysis?.refSamplingProduct?.refCompanyProduct?.refProduct?.refProductType?.id;
            let department = reportDatas.find(it => it.id == analysisDeptId);
            if (analysis.refLabResultStatus?.key == 'Accept') {
                lodash.set(department[`${productTypeId}`], 'countAccept', department[`${productTypeId}`].countAccept + 1);
                lodash.set(department[`${productTypeId}`], 'countTotal', department[`${productTypeId}`].countTotal + 1);
            } else if (analysis.refLabResultStatus?.key == 'Reject' || analysis.refLabResultStatus?.key == 'RejectCanRepeat') {
                lodash.set(department[`${productTypeId}`], 'countReject', department[`${productTypeId}`].countReject + 1);
                lodash.set(department[`${productTypeId}`], 'countTotal', department[`${productTypeId}`].countTotal + 1);
            } else {
                lodash.set(department[`${productTypeId}`], 'countPending', department[`${productTypeId}`].countPending + 1);
                lodash.set(department[`${productTypeId}`], 'countTotal', department[`${productTypeId}`].countTotal + 1);
            }
        });
        data.pageDeptProductType = { ...createPage({ data: reportDatas }) };
        createColumnDeptProductTypes({ data });
        data.isLoadingDeptProductType = false;
    }
};


export const computedReportDeptProductTypeTopic = ({ initData, data }) => {
    if (initData) {
        const { labDepartments, labTopics, productTypes } = initData;
        const parentDepartments =  labDepartments.map(it => it.refParent)
        productTypes.forEach(productType => {
            const reportDatas = reactive([]); // department
            getDeptTblRowColumns({ reportDatas: reportDatas, rowDatas: parentDepartments, colDatas: labTopics });
            state.page.data.forEach(rec => {
                const analysis = lodash.cloneDeep(rec);
                const analysisDeptId = analysis?.refDepartment?.refParent?.id;
                if (analysis.refSamplingProduct?.refCompanyProduct?.refProduct?.refProductType?.key == productType.key) {
                    let reportData = reportDatas.find(it => it.id == analysisDeptId);
                    reportData.refProductType = analysis.refSamplingProduct?.refCompanyProduct?.refProduct?.refProductType?.key;
                    analysis?.topics?.forEach(rec2 => {
                        const topic = lodash.cloneDeep(rec2);
                        const topicId = topic?.refLabTopic?.id;
                        if (topic.refTopicAnalysisStatus?.key == 'Accept') {
                            lodash.set(reportData[`${topicId}`], 'countAccept', reportData[`${topicId}`].countAccept + 1);
                            lodash.set(reportData[`${topicId}`], 'countTotal', reportData[`${topicId}`].countTotal + 1);
                        } else if (topic.refTopicAnalysisStatus?.key == 'Reject' || topic.refTopicAnalysisStatus?.key == 'RejectCanRepeat') {
                            lodash.set(reportData[`${topicId}`], 'countReject', reportData[`${topicId}`].countReject + 1);
                            lodash.set(reportData[`${topicId}`], 'countTotal', reportData[`${topicId}`].countTotal + 1);
                        } else {
                            lodash.set(reportData[`${topicId}`], 'countPending', reportData[`${topicId}`].countPending + 1);
                            lodash.set(reportData[`${topicId}`], 'countTotal', reportData[`${topicId}`].countTotal + 1);
                        }
                    });
                }
            });
            data[`page${productType.valueEn}`] = { ...createPage({ data: reportDatas }) };
            data.isLoadingDeptProdutTypeLabTopic = false;
        });
        createColumnDeptLabTopics({ data });
    }
};

export const createColumns = () => {
    return [
        createColumnInput({
            title: () => i18n.global.t('model.samplingProduct.samplingNo'),
            dataIndex: 'refSamplingProduct.samplingNo',
            align: 'center',
            width: 100
        }),
        createColumnDate({
            title: () => i18n.global.t('model.samplingProductAnalysis.analysisStartDate'),
            dataIndex: 'analysisStartDate',
            align: 'center',
        }),
        createColumnSelect({
            visible: () => false,
            title: () => i18n.global.t("views.report.labPhysic.topic"),
            dataIndex: 'topics',
            inputProp: () => ({
                list: ({ searchQuery }) => callLabTopic({
                    searchQuery,
                    labTypeKey: 'labPhysic',
                    where: [{ name: 'refParent.id', operator: '=', type: 'UUID', value: null }]
                }),
                optLabel: "name",
                mode: "multiple"
            }),
            search: {
                name: "topics.refLabTopic.id",
                operator: "in",
                getValue: ({ value }) => value.filter(d => !d.isDelete).map(d => d.id),
                field: { searchValue: [] }
            },
            align: "center",
        }),
        createColumnSelect({
            visible: () => false,
            title: () => i18n.global.t("views.report.labPhysic.resultByDepartment.department"),
            dataIndex: "refDepartment.refParent.nameTh",
            inputProp: () => ({
                list: ({ searchQuery }) => callDepartment({ searchQuery, refLabTypeKey: 'labPhysic' }),
                mode: "multiple",
                renderLabel: ({ item }) => <div>{item.refParent.nameTh}</div>,
            }),
            search: {
                visible: () => true,
                name: "refDepartment.id",
                operator: "in",
                getValue: ({ value }) => value.filter(d => !d.isDelete).map(d => d.id),
                field: { searchValue: [] }
            },
        }),
    ];
};

export const initState = ({ props, data }) => {
    const menuContext = props.menuContext;
    if (state.columns?.length == 0) {
        state.columns = createColumns({ props });
    }
    data.manages = [createManageExportCsv({ menuContext })];
    data.acceptColumns = computed(() => data.columnProductTypes.filter(d => d.dataIndex.includes('nameTh') || d.dataIndex.includes('countAccept')));
    data.rejectColumns = computed(() => data.columnProductTypes.filter(d => d.dataIndex.includes('nameTh') || d.dataIndex.includes('countReject')));
};

export const state = reactive({
    initData: null,
    columns: [],
    page: createPage({
        options: {
            select: [
                '**',
                'refCreateBy.fullName',
                'refDepartment.refParent.*',
                'refDepartment.refLabType.*',
                'refSamplingProduct.refCompanyProduct.refProduct.refProductType.*'
            ],
        }
    }),
    tableOptions: { search: { activeKey: "Search" } }
});
